import type { MouseEventHandler } from 'react';

export interface JoinEducatorPageData {
  onSignupClick: MouseEventHandler;
}

export interface JoinEducatorPageProps extends JoinEducatorPageData {}
